import { render, staticRenderFns } from "./purchase-amount-form.vue?vue&type=template&id=fd6a0292&scoped=true&"
import script from "./purchase-amount-form.vue?vue&type=script&lang=js&"
export * from "./purchase-amount-form.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount-form.vue?vue&type=style&index=0&id=fd6a0292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6a0292",
  null
  
)

export default component.exports